import { createSlice } from "@reduxjs/toolkit";
import { ICompositeBalance, IInputGSMBalance } from "../../features/BalanceV2/config/interface";
import { toICompositeBalance } from "../../features/BalanceV2/helpers/balanceMapper";
import { ApiResponse } from "../../lib/axios/ApiResponse";
import { clearStore } from "../actions";
import { EN } from "../../data/constants";
import dayjs from "dayjs";

export interface Props {
  balance: ICompositeBalance;
  isQBFailed: boolean;
  isLoanFailed: boolean;
  loanDetails: any;
  balanceLang: string;
}

const initialState: Props = {
  balance: {
    airtimeBal: undefined,
    amBal: undefined,
    voiceBal: undefined,
    dataBal: undefined,
    smsBal: undefined,
    timestamp: undefined,
    refreshGsmBal: false,
    offlineTimeStamp: undefined,
    isAmMasked: true,
    amTimeStamp: "",
    bundlebyCategory: {},
    activePacks: [],
    isFetchingGSMBalance: false,
  },
  isQBFailed: false,
  isLoanFailed: false,
  loanDetails: [],
  balanceLang: process.env.REACT_APP_LANG || EN
};

export const balanceSlice = createSlice({
  name: "balance",
  initialState,
  reducers: {

    //check gsm balance api call reducer
    callCheckGSMBalance: (state, action) => {
      if (action?.payload?.data?.fetchQB)
        state.balance.isFetchingGSMBalance = true;
      state.balanceLang = action.payload.lang;
    },

    callCheckGSMBalanceSuccess: (state, action) => {
      const response = action.payload.data as ApiResponse;
      const inputGSMBalance = response.result as IInputGSMBalance;
      const newGsmBal = toICompositeBalance(inputGSMBalance);
      const ambal = state?.balance?.amBal;
      newGsmBal.timestamp = dayjs().format();
      newGsmBal.offlineTimeStamp = dayjs().format();
      state.balance = newGsmBal;
      state.balance.amBal = ambal;
      state.balance.bundlebyCategory = response.result?.bundlebyCategory;
      state.balance.activePacks = response.result?.activePacks;
      state.balance.refreshGsmBal = false
      state.balance.isFetchingGSMBalance = false;
    },
    callCheckLoanSuccess: (state, action) => {
      const response = action.payload.data as ApiResponse;
      state.isLoanFailed = response.result?.loanFailed
      state.loanDetails = response?.result?.loanDetails?.filter((item: any) => item?.eligible || (!item?.eligible && item?.amountPending))?.map((item:any)=>{
          return {
            ...item,
            eligibilities: item?.eligibilities?.reduce((prv: any, item: any) => {
              return { ...prv, [item?.subType]: { ...item } }
            }, {})

          }
      });
    },

    callCheckGSMBalanceFailure: (state, action) => {
      state.balance.timestamp = dayjs().format();
      state.balance.offlineTimeStamp = dayjs().format()
      state.balance.refreshGsmBal = true
      state.balance.airtimeBal = undefined
      state.balance.amBal = state?.balance?.amBal || undefined
      state.balance.voiceBal = undefined
      state.balance.dataBal = undefined
      state.balance.isFetchingGSMBalance = false;
      state.isLoanFailed = true
      state.loanDetails = []
    },


    //check am balance api call reducer
    callCheckAMBalance: (state, action) => { },

    callCheckAMBalanceSuccess: (state, action) => {
      // if (!state.balance) {
      //   state.balance = { ...initialState.balance };
      // }

      // const amBal = action.payload?.data?.result?.balance?.toLocaleString(
      //   undefined,
      //   { maximumFractionDigits: 2 }
      // );
      // state.balance.amBal = {
      //   total: amBal,
      //   //stores the non trunc value
      //   value: action.payload?.data?.result?.balance,
      //   unit: ""
      // };
      // state.balance.amTimeStamp = dayjs().format();
      if (!state.balance) {
        state.balance = { ...initialState.balance };
      }

      state.balance.amBal = action.payload?.data?.result?.data?.reduce((prvObj: any, item: any) => {
        return {
          ...prvObj,
          [item.currency]: {
            total: item?.balance,
            value: item?.balance,
            unit: item?.currency
          }
        }
      }, {}) ?? {}

      state.balance.amTimeStamp = dayjs().format();
    },

    callCheckAMBalanceFailure: (state, action) => {
    },

    //validate am balance pin api call reducer
    callValidateAMBalancePin: (state, action) => { },

    callValidateAMBalancePinSuccess: (state, action) => { },

    callValidateAMBalancePinFailure: (state, action) => { }
  },

  extraReducers: (builder) => {
    builder //clears everything on 401
      .addCase(clearStore, (state) => {
        return initialState;
      })
      .addDefaultCase((state, action) => { })
  }
});

export const {
  callCheckGSMBalance,
  callCheckGSMBalanceSuccess,
  callCheckGSMBalanceFailure,
  callCheckAMBalance,
  callCheckAMBalanceSuccess,
  callCheckAMBalanceFailure,
  callValidateAMBalancePin,
  callValidateAMBalancePinSuccess,
  callValidateAMBalancePinFailure,
  callCheckLoanSuccess
} = balanceSlice.actions;

export default balanceSlice.reducer;
